import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { isNanoSelector, hasSetupSelector } from '../../app/selectors/appSelectors';
import { isAdminSelector } from '../../auth/selectors/authSelectors';
import { permissionsSelector } from '../../auth/selectors/authSelectors';
import { logOut } from '../../auth/actions/authActions';
import SideBar from '../components/SideBar/SideBar';

const mapStateToProps = createStructuredSelector({
    isAdmin: isAdminSelector,
    permissions: permissionsSelector,
    isNano: isNanoSelector,
    hasSetup: hasSetupSelector
});

const mapDispatchToProps = { logOut };

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SideBar)
);
